// Search Customer & Vehicle

export const SEARCH_CUSTOMER_VEHICLE_REQUEST =
  'SEARCH_CUSTOMER_VEHICLE_REQUEST';
export const SEARCH_CUSTOMER_VEHICLE_SUCCESS =
  'SEARCH_CUSTOMER_VEHICLE_SUCCESS';
export const SEARCH_CUSTOMER_VEHICLE_FAIL = 'SEARCH_CUSTOMER_VEHICLE_FAIL';

export const CLOSE_MORE_VEHICLES_POPUP_ON_SEARCH =
  'CLOSE_MORE_VEHICLES_POPUP_ON_SEARCH';

export const SET_VEHICLES_OF_SELECTED_CUSTOMER =
  'SET_VEHICLES_OF_SELECTED_CUSTOMER';

export const SET_SELECTED_CUSTOMER_AND_VEHICLE =
  'SET_SELECTED_CUSTOMER_AND_VEHICLE';

export const CLEAR_SEARCH_CUSTOMER_VEHICLE_STATE =
  'CLEAR_SEARCH_CUSTOMER_VEHICLE_STATE';

export const CLEAR_ALL_SEARCH_CUSTOMER_VEHICLE_STATES =
  'CLEAR_ALL_SEARCH_CUSTOMER_VEHICLE_STATES';

export const UPDATE_VEHICLE_IMAGES = 'UPDATE_VEHICLE_IMAGES';

export const SET_VEHICLE_FROM_VIN_PLATE_SEARCH_LIST =
  'SET_VEHICLE_FROM_VIN_PLATE_SEARCH_LIST';

export const SET_VEHICLES_FROM_VIN_PLATE_SEARCH_RESULTS =
  'SET_VEHICLES_FROM_VIN_PLATE_SEARCH_RESULTS';

export const CLEAR_STATES_OF_VIN_PLATE_SEARCH_RESULTS =
  'CLEAR_STATES_OF_VIN_PLATE_SEARCH_RESULTS';

// get years
export const GET_YEARS_REQUEST = 'GET_YEARS_REQUEST';
export const GET_YEARS_SUCCESS = 'GET_YEARS_SUCCESS';
export const GET_YEARS_FAIL = 'GET_YEARS_FAIL';

// get makes

export const GET_MAKES_REQUEST = 'GET_MAKES_REQUEST';
export const GET_MAKES_SUCCESS = 'GET_MAKES_SUCCESS';
export const GET_MAKES_FAIL = 'GET_MAKES_FAIL';

// get models

export const GET_MODELS_REQUEST = 'GET_MODELS_REQUEST';
export const GET_MODELS_SUCCESS = 'GET_MODELS_SUCCESS';
export const GET_MODELS_FAIL = 'GET_MODELS_FAIL';

// get engines

export const GET_ENGINES_REQUEST = 'GET_ENGINES_REQUEST';
export const GET_ENGINES_SUCCESS = 'GET_ENGINES_SUCCESS';
export const GET_ENGINES_FAIL = 'GET_ENGINES_FAIL';

// show vehicle information on header

export const SET_VEHICLE_INFO_ON_HEADER = 'SET_VEHICLE_INFO_ON_HEADER';
